import { render, staticRenderFns } from "./groupMember.vue?vue&type=template&id=624d00ac&"
import script from "./groupMember.vue?vue&type=script&lang=ts&"
export * from "./groupMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports